import React from 'react';
import TileLayer from 'ol/layer/Tile';

export const TileLayerContext = React.createContext<TileLayer<any> | null>(null);

